<template>
  <div class="input-togglebar" :id="iuid">
    <button
      v-for="(item, idx) in options"
      :key="`${iuid}-item-${idx}`"
      :class="{ selected: item.value === ivalue }"
      @click="handleButtonClick(item.value)">
      <Icon v-if="item.icon" :name="item.icon" />
      <span>{{ item.label }}</span>
      <span v-if="item.count" class="bubble">{{ item.count }}</span>
    </button>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  let uid = 0;

  export default {
    name: 'ToggleBar',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      value: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      uid += 1;
      return {
        iuid: `input-togglebar-${uid}`,
        ivalue: this.value || null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      value(val) {
        this.ivalue = val;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      handleButtonClick(value) {
        this.ivalue = value;
        this.$emit('update:value', value);
        this.$emit('input', value);
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.input-togglebar {
  display: inline-block;
  height: 48px;
  padding: 8px;
  background-color: $color-black-alpha-10;
  border-radius: $default-border-radius;

  button {
    @include font-body-small;
    position: relative;
    padding: 8px 12px;
    border: 0;
    margin-right: 12px;
    &:last-of-type { margin-right: 0; }
    cursor: pointer;
    background-color: transparent;
    z-index: 1;
    outline: 0;


    &:before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid transparent;
      border-radius: $default-border-radius / 2;
      background-color: transparent;
      box-shadow: $box-shadow-0;
      will-change: background-color, box-shadow;
      transition: border $default-transition, background-color $default-transition, box-shadow $default-transition;
      z-index: -1;
    }

    &.selected:before {
      background-color: $color-white-solid-10;
      box-shadow: $box-shadow-1;
      border: 1px solid transparent;
      animation: blip 0.15s ease forwards;
      opacity: 1;
    }

    &:focus:before {
      box-shadow: $box-shadow-1;
      border: 1px solid $color-black-alpha-20;
    }
    &.selected:focus:before {
      border: 1px solid transparent;
    }

    & > svg {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translate(0, -50%);
      width: 18px;
      height: auto;
    }

    & > span { user-select: none; }
    & > svg + span { margin-left: 22px; }
    & > span.bubble {
      @include font-body-tiny-semibold;
      position: absolute;
      border-radius: 100%;
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-blue-solid-100;
      color: $color-white-solid-10;
      top: -4.5px;
      right: -4.5px;
    }
  }
}
</style>
